if (typeof SocialMediaFeed === 'undefined') {
  class SocialMediaFeed extends HTMLElement {
    connectedCallback() {
      this._initItems();
    }

    _initItems() {
      this.querySelectorAll('.smf-item').forEach(item => {
        const video = item.querySelector('.smf-video');
        if (!video) return;

        // ── Desktop hover ──────────────────────────────────
        item.addEventListener('mouseenter', () => this._play(item, video));
        item.addEventListener('mouseleave', () => this._pause(item, video));

        // ── Mobile tap toggle ──────────────────────────────
        item.addEventListener('touchend', e => {
          if (item.classList.contains('is-playing')) {
            this._pause(item, video);
          } else {
            // Pause any other playing item first
            this.querySelectorAll('.smf-item.is-playing').forEach(other => {
              const v = other.querySelector('.smf-video');
              if (v) this._pause(other, v);
            });
            this._play(item, video);
          }
        }, { passive: true });
      });

      // Pause all when mouse leaves the whole grid
      const grid = this.querySelector('.smf-grid');
      if (grid) {
        grid.addEventListener('mouseleave', () => {
          this.querySelectorAll('.smf-item.is-playing').forEach(item => {
            const v = item.querySelector('.smf-video');
            if (v) this._pause(item, v);
          });
        });
      }
    }

    _play(item, video) {
      item.classList.add('is-playing');
      video.play().catch(() => {
        // Autoplay blocked — remove class so thumbnail stays visible
        item.classList.remove('is-playing');
      });
    }

    _pause(item, video) {
      item.classList.remove('is-playing');
      video.pause();
      video.currentTime = 0;
    }
  }

  customElements.define('social-media-feed', SocialMediaFeed);
  document.addEventListener('shopify:section:load', e => {
    const el = e.target.querySelector('social-media-feed');
    if (el) el.connectedCallback();
  });
}
